module.exports = __webpack_public_path__ + "img/qualty_set.6af7f1f8.svg";